import React from 'react';
import OrderListComponent from '../../Components/OrderList/OrderListComponent';
import Summary from '../../Summary/Summary';
import { useSelector } from 'react-redux';
import BackButton from '../../Components/BackButton';

const OrderDetailsPage = () => {
  const { orderItems, quantity } = useSelector((store) => store.order);

  return (
    <section className="lg:mb-10 mt-10 h-auto">
      <div className="ml-7 sm:ml-0">
        <BackButton />
      </div>
      <div className="mx-6 lg:mx-10 my-4">
        <div className="flex items-center gap-10 mb-14">
          <h2 className="text-4xl">Order Details</h2>
          <p className="text-dark-3 font-semibold">{quantity} items</p>
        </div>
      </div>
      {/* Order list */}

      <div className="flex relative h-auto">
        <div className="flex flex-col w-full lg:w-1/2 mx-4 md:mx-12 gap-6 mb-56 lg:mb-0">
          {orderItems.map((item) => {
            return <OrderListComponent key={item.id} {...item} />;
          })}
        </div>

        {/*summary  */}
        <div
          className=" lg:w-2/5 lg:relative lg:right-0 fixed bottom-0 lg:mr-12  w-full 
        "
        >
          <Summary />
        </div>
      </div>
    </section>
  );
};

export default OrderDetailsPage;
